// import {} from '@/store/api/center';

const states = {
};

const mutations = {
};

const getters = {
};

const actions = {
    // getCollectInfo({ commit }, payload) {
    //     const param = { businessId: payload.id };
    //     return getCollectApi(param).then((res) => {
    //         commit('setCollectID', res.data.id);
    //         return res.data;
    //     });
    // },
};

export default {
    namespaced: true,
    getters,
    actions,
    mutations,
    state: states
};

